// extracted by mini-css-extract-plugin
export default {"autoActionScreen":"Join_autoActionScreen__w-9O8","gcLogo":"Join_gcLogo__M4mkp","roomCode":"Join_roomCode__7tOki","cancelButton":"Join_cancelButton__kGEA-"};